import React from "react";
import FoodProductCodeField from "./FoodProductCodeField";
import { thisBaseURL } from "../../utils/helper.js";

function FoodProductCodes({foodAnswers}){
	let defaultSlug = foodAnswers.answerKeyValues["food_slug"];
	let fdaIndustryCode = foodAnswers.answerKeyValues['fda_industry_code_and_general_industry_description'];
	let fdaIndustryCodeArr = [];
	if(fdaIndustryCode){
		try {
			fdaIndustryCodeArr = JSON.parse(fdaIndustryCode);
		} catch (err) {
			console.log("FoodProductCodes :fdaIndustryCode: " +err);
		}
	}
	let fdaIndustryCodeSourceRef = foodAnswers.answerKeyValues['fda_industry_code_and_general_industry_description_sources'];
	
	let htsCodeYear = foodAnswers.answerKeyValues['hts_code_s__year'];
	let htsCodeSourceRef = foodAnswers.answerKeyValues['hts_code_s__sources'];
	let htsCodeNotes = foodAnswers.answerKeyValues['hts_code_s__notes'];
	let htsCode = foodAnswers.answerKeyValues['hts_code_s_'];
	
	let htsCodeArr = [];
	if(htsCode){
		try {
			htsCodeArr = JSON.parse(htsCode);
		} catch (err) {
			console.log("FoodProductCodes :htsCode: " +err);
		}
	}
	
	let usdaCodeYear = foodAnswers.answerKeyValues['usda_ndb_code_s__year'];
	let usdaCodeSourceRef = foodAnswers.answerKeyValues['usda_ndb_code_s__sources'];
	let usdaCodeNotes = foodAnswers.answerKeyValues['usda_ndb_code_s__notes'];
	let usdaCode = foodAnswers.answerKeyValues['usda_ndb_code_s_'];
	let usdaCodeArr = [];
	if(usdaCode){
		try {
			usdaCodeArr = JSON.parse(usdaCode);
		} catch (err) {
			console.log("FoodProductCodes :usdaCode: " +err);
		}
	}
	
	return(<div className="question-grouping" id="food_product_codes">
				<h2>Food Product Codes</h2>
				<p></p>
				<div className="clearfix" style={{marginBottom: "20px"}}>
					<h3>
						FDA Industry Code and General Industry Description
						{fdaIndustryCodeSourceRef && fdaIndustryCodeSourceRef > 0 ? 
						<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+fdaIndustryCodeSourceRef}>{fdaIndustryCodeSourceRef}</a></small>
						: ""}
					</h3>
					<table style={{width:"100%", float:"left", marginBottom:"20px"}}>
						<thead>
							<tr>
								<th style={{width:"30%"}}>FDA Industry Code</th>
								<th>Description of Product</th>
							</tr>
						</thead>
						<tbody>
							<FoodProductCodeField foodProductCodeArr={{fdaIndustryCodeArr}} by="fda"/>
						</tbody>
					</table>
				</div>
				<div className="clearfix" style={{marginBottom: "20px"}}>
					<h3>
						HTS code(s)
						{htsCodeYear ? 
						<small>&nbsp;({htsCodeYear})</small>
						: ""}
						
						{htsCodeSourceRef && htsCodeSourceRef > 0 ? 
						<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+htsCodeSourceRef}>{htsCodeSourceRef}</a></small>
						: ""}
					</h3>
					<table style={{width:"100%", float:"left", marginBottom:"20px"}}>
						<thead>
							<tr>
								<th style={{width:"30%"}}>HTS Code</th>
								<th>Description of Product</th>
							</tr>
						</thead>
						<tbody>
							<FoodProductCodeField foodProductCodeArr={{htsCodeArr}} by="hts"/>
						</tbody>
					</table>
					{htsCodeNotes ? 
						<p className="notes-info" style={{marginTop: "auto"}}>
						<em>{htsCodeNotes}</em>
						</p>
					: ""}
				</div>
				<div className="clearfix" style={{marginBottom: "20px"}}>
					<h3>
						USDA NDB code(s)
						{usdaCodeYear ? 
						<small>&nbsp;({usdaCodeYear})</small>
						: ""}
						
						{usdaCodeSourceRef && usdaCodeSourceRef > 0 ? 
						<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+usdaCodeSourceRef}>{usdaCodeSourceRef}</a></small>
						: ""}
					</h3>
					<table style={{width:"100%", float:"left", marginBottom:"20px"}}>
						<thead>
							<tr>
								<th style={{width:"30%"}}>USDA NDB Code</th>
								<th>Description of Product</th>
							</tr>
						</thead>
						<tbody>
							<FoodProductCodeField foodProductCodeArr={{usdaCodeArr}} by="usda"/>
						</tbody>
					</table>
					{usdaCodeNotes  ? 
						<p className="notes-info" style={{marginTop: "auto"}}>
						<em>{usdaCodeNotes}</em>
						</p>
					: ""}
				</div>
			</div>);
}
export default FoodProductCodes;